import { render, staticRenderFns } from "./HKWebSocket.vue?vue&type=template&id=53367aa1"
import script from "./HKWebSocket.vue?vue&type=script&lang=js"
export * from "./HKWebSocket.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_85bb6ef93cf5a779f9b064f420832c70/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports